import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center text-center whitespace-nowrap leading-none rounded-xl font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forest-600 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&>svg]:shrink-0';
  const variants = {
    primary: 'bg-forest-600 text-white hover:bg-forest-700 shadow-sm',
    secondary: 'bg-ivory-200 text-forest-700 hover:bg-stone-200',
    outline: 'border border-beige bg-ivory-200 hover:bg-ivory text-forest-800',
    ghost: 'hover:bg-ivory-200 text-forest-700 hover:text-forest-900'
  };
  const sizes = {
    sm: 'h-10 px-4 text-sm gap-1.5',
    md: 'h-12 px-6 text-[15px] sm:text-base gap-2',
    lg: 'h-[52px] sm:h-14 px-6 sm:px-8 text-base sm:text-[17px] gap-2'
  };
  return <button className={`
        ${baseStyles}
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} disabled={disabled || isLoading} {...props} data-id="element-465">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-466" />}
      {children}
    </button>;
}